import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { LINK_PREVIEW_TYPE } from "../types.js";
import { EmbedViewer } from "./embed-viewer.js";
const Embed = ({ node, nodeIndex, NodeViewContainer }) => {
  const { iframeSandboxDomain, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    EmbedViewer,
    {
      node,
      settings: config[LINK_PREVIEW_TYPE],
      iframeSandboxDomain: iframeSandboxDomain || ""
    }
  ));
};
var embed_default = Embed;
export {
  Embed,
  embed_default as default
};
//# sourceMappingURL=embed.js.map

import "@wix/ricos/css/plugin-link-preview-viewer.global.css";